import { render, staticRenderFns } from "./MediakitPropertyDialog.vue?vue&type=template&id=7450fb34&"
import script from "./MediakitPropertyDialog.vue?vue&type=script&lang=js&"
export * from "./MediakitPropertyDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports